// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Code Block Wrapper */
.code-block-wrapper {
  position: relative;
  margin: 15px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: var(--background-color);
  border: 1px solid #e0e0e0;
}

[data-theme='dark'] .code-block-wrapper {
  background: var(--background-color);
  border-color: #555;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Code Block */
.code-block {
  background: #f8f9fa;
  border: none;
  border-radius: 0;
  padding: 16px;
  margin: 0;
  overflow-x: auto;
  font-family: 'Courier New', 'Monaco', 'Consolas', monospace;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
  position: relative;
  cursor: context-menu;
  -webkit-user-select: text;
          user-select: text;
}

[data-theme='dark'] .code-block {
  background: #2d3748;
  color: #e2e8f0;
}

.code-block:hover {
  background: #f1f3f4;
}

[data-theme='dark'] .code-block:hover {
  background: #4a5568;
}

/* Code Block Header */
.code-block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background: #e9ecef;
  border-top: 1px solid #dee2e6;
  font-size: 12px;
  color: #6c757d;
}

[data-theme='dark'] .code-block-header {
  background: #1a202c;
  border-top-color: #4a5568;
  color: #adb5bd;
}

.code-language {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.code-block-actions {
  display: flex;
  gap: 8px;
}

.code-action-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  transition: background-color 0.2s;
  opacity: 0.7;
}

.code-action-btn:hover {
  background: rgba(0, 0, 0, 0.1);
  opacity: 1;
}

[data-theme='dark'] .code-action-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* Inline Code */
.code-inline {
  background: #f1f3f4;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', 'Monaco', 'Consolas', monospace;
  font-size: 0.9em;
  color: #d63384;
  cursor: context-menu;
  -webkit-user-select: text;
          user-select: text;
  position: relative;
  display: inline-block;
}

[data-theme='dark'] .code-inline {
  background: #2d3748;
  color: #f093fb;
}

.code-inline:hover {
  background: #e9ecef;
}

[data-theme='dark'] .code-inline:hover {
  background: #4a5568;
}

/* Code Block Interactive States */
.code-block-interactive {
  position: relative;
  transition: all 0.2s ease;
}

.code-block-interactive::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  border-radius: 8px;
  transition: all 0.2s ease;
  z-index: 1;
}

.code-block-interactive:hover::before {
  box-shadow: inset 0 0 0 2px rgba(0, 123, 255, 0.2);
}

[data-theme='dark'] .code-block-interactive:hover::before {
  box-shadow: inset 0 0 0 2px rgba(74, 144, 226, 0.3);
}

/* Code Block Content */
.code-block code {
  background: none;
  padding: 0;
  border: none;
  border-radius: 0;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  white-space: inherit;
  word-wrap: inherit;
}

/* Syntax Highlighting Support */
.code-block .token.comment,
.code-block .token.prolog,
.code-block .token.doctype,
.code-block .token.cdata {
  color: #6c757d;
}

.code-block .token.punctuation {
  color: #6c757d;
}

.code-block .token.property,
.code-block .token.tag,
.code-block .token.boolean,
.code-block .token.number,
.code-block .token.constant,
.code-block .token.symbol,
.code-block .token.deleted {
  color: #e74c3c;
}

.code-block .token.selector,
.code-block .token.attr-name,
.code-block .token.string,
.code-block .token.char,
.code-block .token.builtin,
.code-block .token.inserted {
  color: #28a745;
}

.code-block .token.operator,
.code-block .token.entity,
.code-block .token.url,
.code-block .language-css .token.string,
.code-block .style .token.string {
  color: #fd7e14;
}

.code-block .token.atrule,
.code-block .token.attr-value,
.code-block .token.keyword {
  color: #007bff;
}

.code-block .token.function,
.code-block .token.class-name {
  color: #6f42c1;
}

.code-block .token.regex,
.code-block .token.important,
.code-block .token.variable {
  color: #e83e8c;
}

/* Dark theme syntax highlighting */
[data-theme='dark'] .code-block .token.comment,
[data-theme='dark'] .code-block .token.prolog,
[data-theme='dark'] .code-block .token.doctype,
[data-theme='dark'] .code-block .token.cdata {
  color: #adb5bd;
}

[data-theme='dark'] .code-block .token.punctuation {
  color: #adb5bd;
}

[data-theme='dark'] .code-block .token.property,
[data-theme='dark'] .code-block .token.tag,
[data-theme='dark'] .code-block .token.boolean,
[data-theme='dark'] .code-block .token.number,
[data-theme='dark'] .code-block .token.constant,
[data-theme='dark'] .code-block .token.symbol,
[data-theme='dark'] .code-block .token.deleted {
  color: #f56565;
}

[data-theme='dark'] .code-block .token.selector,
[data-theme='dark'] .code-block .token.attr-name,
[data-theme='dark'] .code-block .token.string,
[data-theme='dark'] .code-block .token.char,
[data-theme='dark'] .code-block .token.builtin,
[data-theme='dark'] .code-block .token.inserted {
  color: #68d391;
}

[data-theme='dark'] .code-block .token.operator,
[data-theme='dark'] .code-block .token.entity,
[data-theme='dark'] .code-block .token.url,
[data-theme='dark'] .code-block .language-css .token.string,
[data-theme='dark'] .code-block .style .token.string {
  color: #fbb6ce;
}

[data-theme='dark'] .code-block .token.atrule,
[data-theme='dark'] .code-block .token.attr-value,
[data-theme='dark'] .code-block .token.keyword {
  color: #63b3ed;
}

[data-theme='dark'] .code-block .token.function,
[data-theme='dark'] .code-block .token.class-name {
  color: #b794f6;
}

[data-theme='dark'] .code-block .token.regex,
[data-theme='dark'] .code-block .token.important,
[data-theme='dark'] .code-block .token.variable {
  color: #f687b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .code-block {
    padding: 12px;
    font-size: 13px;
  }
  
  .code-block-header {
    padding: 6px 12px;
    font-size: 11px;
  }
  
  .code-action-btn {
    padding: 3px 6px;
    font-size: 12px;
  }
  
  .code-inline {
    padding: 1px 4px;
    font-size: 0.85em;
  }
}

/* Scrollbar Styling */
.code-block::-webkit-scrollbar {
  height: 8px;
}

.code-block::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

[data-theme='dark'] .code-block::-webkit-scrollbar-track {
  background: #2d3748;
}

.code-block::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

[data-theme='dark'] .code-block::-webkit-scrollbar-thumb {
  background: #4a5568;
}

.code-block::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

[data-theme='dark'] .code-block::-webkit-scrollbar-thumb:hover {
  background: #718096;
}

/* Animation for notifications */
@keyframes notificationSlideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Focus states for accessibility */
.code-block:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

[data-theme='dark'] .code-block:focus {
  outline-color: #4a90e2;
}

.code-action-btn:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

[data-theme='dark'] .code-action-btn:focus {
  outline-color: #4a90e2;
}
`, "",{"version":3,"sources":["webpack://./src/components/CodeBlock.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Code Block Wrapper */\n.code-block-wrapper {\n  position: relative;\n  margin: 15px 0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  background: var(--background-color);\n  border: 1px solid #e0e0e0;\n}\n\n[data-theme='dark'] .code-block-wrapper {\n  background: var(--background-color);\n  border-color: #555;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n/* Code Block */\n.code-block {\n  background: #f8f9fa;\n  border: none;\n  border-radius: 0;\n  padding: 16px;\n  margin: 0;\n  overflow-x: auto;\n  font-family: 'Courier New', 'Monaco', 'Consolas', monospace;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #333;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  position: relative;\n  cursor: context-menu;\n  user-select: text;\n}\n\n[data-theme='dark'] .code-block {\n  background: #2d3748;\n  color: #e2e8f0;\n}\n\n.code-block:hover {\n  background: #f1f3f4;\n}\n\n[data-theme='dark'] .code-block:hover {\n  background: #4a5568;\n}\n\n/* Code Block Header */\n.code-block-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n  background: #e9ecef;\n  border-top: 1px solid #dee2e6;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n[data-theme='dark'] .code-block-header {\n  background: #1a202c;\n  border-top-color: #4a5568;\n  color: #adb5bd;\n}\n\n.code-language {\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.code-block-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.code-action-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: background-color 0.2s;\n  opacity: 0.7;\n}\n\n.code-action-btn:hover {\n  background: rgba(0, 0, 0, 0.1);\n  opacity: 1;\n}\n\n[data-theme='dark'] .code-action-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Inline Code */\n.code-inline {\n  background: #f1f3f4;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', 'Monaco', 'Consolas', monospace;\n  font-size: 0.9em;\n  color: #d63384;\n  cursor: context-menu;\n  user-select: text;\n  position: relative;\n  display: inline-block;\n}\n\n[data-theme='dark'] .code-inline {\n  background: #2d3748;\n  color: #f093fb;\n}\n\n.code-inline:hover {\n  background: #e9ecef;\n}\n\n[data-theme='dark'] .code-inline:hover {\n  background: #4a5568;\n}\n\n/* Code Block Interactive States */\n.code-block-interactive {\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.code-block-interactive::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  z-index: 1;\n}\n\n.code-block-interactive:hover::before {\n  box-shadow: inset 0 0 0 2px rgba(0, 123, 255, 0.2);\n}\n\n[data-theme='dark'] .code-block-interactive:hover::before {\n  box-shadow: inset 0 0 0 2px rgba(74, 144, 226, 0.3);\n}\n\n/* Code Block Content */\n.code-block code {\n  background: none;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n  white-space: inherit;\n  word-wrap: inherit;\n}\n\n/* Syntax Highlighting Support */\n.code-block .token.comment,\n.code-block .token.prolog,\n.code-block .token.doctype,\n.code-block .token.cdata {\n  color: #6c757d;\n}\n\n.code-block .token.punctuation {\n  color: #6c757d;\n}\n\n.code-block .token.property,\n.code-block .token.tag,\n.code-block .token.boolean,\n.code-block .token.number,\n.code-block .token.constant,\n.code-block .token.symbol,\n.code-block .token.deleted {\n  color: #e74c3c;\n}\n\n.code-block .token.selector,\n.code-block .token.attr-name,\n.code-block .token.string,\n.code-block .token.char,\n.code-block .token.builtin,\n.code-block .token.inserted {\n  color: #28a745;\n}\n\n.code-block .token.operator,\n.code-block .token.entity,\n.code-block .token.url,\n.code-block .language-css .token.string,\n.code-block .style .token.string {\n  color: #fd7e14;\n}\n\n.code-block .token.atrule,\n.code-block .token.attr-value,\n.code-block .token.keyword {\n  color: #007bff;\n}\n\n.code-block .token.function,\n.code-block .token.class-name {\n  color: #6f42c1;\n}\n\n.code-block .token.regex,\n.code-block .token.important,\n.code-block .token.variable {\n  color: #e83e8c;\n}\n\n/* Dark theme syntax highlighting */\n[data-theme='dark'] .code-block .token.comment,\n[data-theme='dark'] .code-block .token.prolog,\n[data-theme='dark'] .code-block .token.doctype,\n[data-theme='dark'] .code-block .token.cdata {\n  color: #adb5bd;\n}\n\n[data-theme='dark'] .code-block .token.punctuation {\n  color: #adb5bd;\n}\n\n[data-theme='dark'] .code-block .token.property,\n[data-theme='dark'] .code-block .token.tag,\n[data-theme='dark'] .code-block .token.boolean,\n[data-theme='dark'] .code-block .token.number,\n[data-theme='dark'] .code-block .token.constant,\n[data-theme='dark'] .code-block .token.symbol,\n[data-theme='dark'] .code-block .token.deleted {\n  color: #f56565;\n}\n\n[data-theme='dark'] .code-block .token.selector,\n[data-theme='dark'] .code-block .token.attr-name,\n[data-theme='dark'] .code-block .token.string,\n[data-theme='dark'] .code-block .token.char,\n[data-theme='dark'] .code-block .token.builtin,\n[data-theme='dark'] .code-block .token.inserted {\n  color: #68d391;\n}\n\n[data-theme='dark'] .code-block .token.operator,\n[data-theme='dark'] .code-block .token.entity,\n[data-theme='dark'] .code-block .token.url,\n[data-theme='dark'] .code-block .language-css .token.string,\n[data-theme='dark'] .code-block .style .token.string {\n  color: #fbb6ce;\n}\n\n[data-theme='dark'] .code-block .token.atrule,\n[data-theme='dark'] .code-block .token.attr-value,\n[data-theme='dark'] .code-block .token.keyword {\n  color: #63b3ed;\n}\n\n[data-theme='dark'] .code-block .token.function,\n[data-theme='dark'] .code-block .token.class-name {\n  color: #b794f6;\n}\n\n[data-theme='dark'] .code-block .token.regex,\n[data-theme='dark'] .code-block .token.important,\n[data-theme='dark'] .code-block .token.variable {\n  color: #f687b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .code-block {\n    padding: 12px;\n    font-size: 13px;\n  }\n  \n  .code-block-header {\n    padding: 6px 12px;\n    font-size: 11px;\n  }\n  \n  .code-action-btn {\n    padding: 3px 6px;\n    font-size: 12px;\n  }\n  \n  .code-inline {\n    padding: 1px 4px;\n    font-size: 0.85em;\n  }\n}\n\n/* Scrollbar Styling */\n.code-block::-webkit-scrollbar {\n  height: 8px;\n}\n\n.code-block::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n[data-theme='dark'] .code-block::-webkit-scrollbar-track {\n  background: #2d3748;\n}\n\n.code-block::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n[data-theme='dark'] .code-block::-webkit-scrollbar-thumb {\n  background: #4a5568;\n}\n\n.code-block::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n[data-theme='dark'] .code-block::-webkit-scrollbar-thumb:hover {\n  background: #718096;\n}\n\n/* Animation for notifications */\n@keyframes notificationSlideIn {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Focus states for accessibility */\n.code-block:focus {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n\n[data-theme='dark'] .code-block:focus {\n  outline-color: #4a90e2;\n}\n\n.code-action-btn:focus {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n\n[data-theme='dark'] .code-action-btn:focus {\n  outline-color: #4a90e2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
